import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { TemplateTypeRes } from '../patients/index.type';

type TemplateItem = {
  key: string;
  title: string;
};

const useFetchType = () => {
  const [templateType, setTemplateType] = React.useState<TemplateItem[]>([]);

  const { loading: fetchingTemplateType, makeApiCall } = useApi({
    url: `/rtm/template/type`,
    method: 'GET',
  });

  const fetchTemplateType = async () => {
    const { response, error } = await makeApiCall<undefined, TemplateTypeRes>();

    if (response?.status) {
      setTemplateType(response.data);
    } else {
      setTemplateType([]);
      toast.error('Something went wrong while fetching template type. Please try again later');
    }
  };

  return {
    templateType,
    fetchTemplateType,
    fetchingTemplateType,
  };
};

export default useFetchType;
